export const BRAND = {
  name: "Blacklion",
  fullName: "Blacklion Construction Group Inc.",
  url: "https://www.blacklionconstructiongroup.com",
  heroBg: "/images/hero-bg.png",
  aboutPhoto: "https://images.unsplash.com/photo-1615406020658-6c4b805f1f30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwYnVpbGRpbmclMjBleHRlcmlvcnxlbnwwfHx8fDE3ODMxMDIxNzB8MA&ixlib=rb-4.1.0&q=85",
  phone: "647.967.8994",
  phoneHref: "tel:+16479678994",
  email: "info@blacklionconstruction.com",
  serviceArea: "Toronto & GTA",
  serviceCities: ["Toronto", "Etobicoke", "Scarborough", "North York", "Mississauga", "Oakville"],
  instagramHandle: "bcg.construction",
  socials: {
    instagram: "https://www.instagram.com/bcg.construction/",
    facebook: "https://www.facebook.com/blacklionconstructiongroup/",
    houzz: "https://www.houzz.com/pro/webuser-194835427/blacklion-construction-group-inc",
  },
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Why Us", href: "#why-us" },
  { label: "Reviews", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    title: "Construction Management",
    desc: "From permits to final walkthrough, we've got you covered. Our team coordinates and liaises with all key parties to take your concepts from planning right through to execution and completion.",
    image: "/images/services/construction-management.png",
  },
  {
    title: "Custom Homes",
    desc: "Bespoke residences engineered from the ground up, built with care, attention to detail and a relentless commitment to our craft.",
    image: "/images/services/custom-homes.jpg",
  },
  {
    title: "Renovations and Additions",
    desc: "Full-scale additions, top-ups and renovations that capture our clients' and designers' visions and bring them to life.",
    image: "/images/services/renovations-additions.jpg",
  },
  {
    title: "Kitchen and Bathroom Remodels",
    desc: "High-craft remodels balancing everyday function with premium, lasting finishes.",
    image: "/images/services/kitchen-bathroom-remodels.png",
  },
  {
    title: "Basement Upgrades and Underpinning",
    desc: "Structural underpinning and basement enhancement to unlock your home's hidden potential and maximise your living space.",
    image: "/images/services/basement-upgrades.jpg",
  },
  {
    title: "Attic Conversions",
    desc: "Transform your attic into a functional, free-flowing space that blends seamlessly with the rest of your home.",
    image: "/images/services/attic-conversions.jpg",
  },
];

export const WHY_US = [
  {
    num: "01",
    icon: "Award",
    title: "Proven Craftsmanship",
    desc: "Crafting excellence and building trust, we are committed to delivering premium residential custom builds across the Greater Toronto Area.",
  },
  {
    num: "02",
    icon: "ShieldCheck",
    title: "Licensed & Insured",
    desc: "Fully licensed, bonded and insured. Your investment is protected at every stage of the project.",
  },
  {
    num: "03",
    icon: "BadgeCheck",
    title: "Quality Guarantee",
    desc: "We stand behind every nail, beam and detail with a workmanship guarantee that outlasts the test of time.",
  },
  {
    num: "04",
    icon: "CalendarClock",
    title: "On-Time Delivery",
    desc: "Disciplined scheduling and proactive communication keep your build on track and on budget.",
  },
];

export const PORTFOLIO_PILLARS = [
  "Uncompromising Precision",
  "Structural Integrity",
  "Bespoke Finishes",
  "Timeless Form",
];

export const PORTFOLIO_CATEGORIES = [
  {
    slug: "kitchens",
    title: "Kitchens",
    subtitle: "Custom Kitchens",
    color: "#c9a24d",
    cover: "/images/portfolio/professional-kitchen-custom-countertops.jpg",
    images: [
      { src: "/images/portfolio/professional-kitchen-custom-countertops.jpg", alt: "Custom kitchen with professional-grade countertops" },
      { src: "/images/portfolio/custom-kitchen-island.jpg", alt: "Custom kitchen island" },
      { src: "/images/portfolio/custom-kitchen-cabinetry.jpg", alt: "Custom kitchen cabinetry" },
      { src: "/images/portfolio/custom-kitchen-range.jpg", alt: "Custom kitchen range wall" },
      { src: "/images/portfolio/custom-cabinetry-island-colours.jpg", alt: "Custom cabinetry with coloured island" },
      { src: "/images/portfolio/custom-cabinetry-millwork.jpg", alt: "Custom cabinetry millwork detail" },
      { src: "/images/portfolio/custom-colourful-kitchen.png", alt: "Colourful custom kitchen" },
      { src: "/images/portfolio/kitchen-island-cabinetry.jpg", alt: "Kitchen island cabinetry" },
    ],
  },
  {
    slug: "bathrooms",
    title: "Bathrooms",
    subtitle: "Spa-Inspired Baths",
    color: "#7d97a8",
    cover: "/images/portfolio/custom-bathroom-shower.jpg",
    images: [
      { src: "/images/portfolio/custom-bathroom-shower.jpg", alt: "Custom bathroom shower" },
      { src: "/images/portfolio/bathroom-tiles-vanity.jpg", alt: "Bathroom tile and vanity" },
      { src: "/images/portfolio/colourful-bathroom-bathtub.jpg", alt: "Colourful bathroom with freestanding bathtub" },
      { src: "/images/portfolio/custom-colourful-bathroom.jpg", alt: "Custom colourful bathroom" },
      { src: "/images/portfolio/his-and-hers-bathroom.jpg", alt: "His and hers bathroom" },
      { src: "/images/portfolio/miniminalist-bathroom.jpg", alt: "Minimalist bathroom" },
      { src: "/images/portfolio/modern-bathroom-slidingdoor.jpg", alt: "Modern bathroom with sliding glass door" },
      { src: "/images/portfolio/modern-bathroom-vanity.jpg", alt: "Modern bathroom vanity" },
      { src: "/images/portfolio/modern-bathtub-bathroom.jpg", alt: "Modern bathtub bathroom" },
    ],
  },
  {
    slug: "living-spaces",
    title: "Living Spaces",
    subtitle: "Open-Concept Living",
    color: "#96a06c",
    cover: "/images/portfolio/modern-livingroom-wooden.png",
    images: [
      { src: "/images/portfolio/modern-livingroom-wooden.png", alt: "Modern living room with wooden accents" },
      { src: "/images/portfolio/basement-modern-fireplace.jpg", alt: "Modern basement with fireplace" },
      { src: "/images/portfolio/custom-basement-livingspace.png", alt: "Custom basement living space" },
      { src: "/images/portfolio/custom-bedroom.png", alt: "Custom bedroom" },
      { src: "/images/portfolio/custom-entryway.jpg", alt: "Custom entryway" },
      { src: "/images/portfolio/custom-living-space-dining-family.jpg", alt: "Custom living, dining and family space" },
      { src: "/images/portfolio/custom-livingspace-renovation.jpg", alt: "Custom living space renovation" },
      { src: "/images/portfolio/redesigned-loft-livingspace.jpg", alt: "Redesigned loft living space" },
      { src: "/images/portfolio/cozy-diningroom.jpg", alt: "Cozy dining room" },
      { src: "/images/portfolio/wooden-diningroom-space2.jpg", alt: "Wooden dining room space" },
    ],
  },
  {
    slug: "outdoor-spaces",
    title: "Outdoor Spaces",
    subtitle: "Decks & Outdoor Living",
    color: "#b97a4d",
    cover: "/images/portfolio/custom-outdoor-living.jpg",
    images: [
      { src: "/images/portfolio/custom-outdoor-living.jpg", alt: "Custom outdoor living space" },
      { src: "/images/portfolio/custom-deck.jpg", alt: "Custom deck build" },
      { src: "/images/portfolio/custom-outdoor-woodwork.jpg", alt: "Custom outdoor woodwork" },
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Blacklion delivered our custom home exactly as promised, on time, on budget, and finished to a standard we didn't think was possible. True craftsmen.",
    name: "Michael & Sarah T.",
    role: "Custom Home Client, Vaughan",
  },
  {
    quote:
      "Their project management was flawless. Every trade was coordinated, every deadline was met, and communication was constant. A genuinely premium experience.",
    name: "David R.",
    role: "Commercial Developer, Toronto",
  },
  {
    quote:
      "We renovated our entire main floor and the transformation is stunning. The attention to detail and the quality of the finishes speak for themselves.",
    name: "Priya S.",
    role: "Renovation Client, Mississauga",
  },
];

export const STATS = [
  { value: 15, suffix: "+", label: "Years Building" },
  { value: 200, suffix: "+", label: "Projects Delivered" },
  { value: 100, suffix: "%", label: "Licensed & Insured" },
  { value: "GTA", label: "Service Area", isStatic: true },
];

export const FAQS = [
  {
    question: "What areas does Blacklion Construction Group serve?",
    answer:
      "Blacklion Construction Group is a Toronto general contractor serving homeowners and developers across the Greater Toronto Area, including Toronto, Etobicoke, Scarborough, North York, Mississauga and Oakville. Wherever your property is in the GTA, our team can manage your custom home, renovation or commercial build from permits to final walkthrough.",
  },
  {
    question: "Is Blacklion Construction Group licensed and insured in Toronto?",
    answer:
      "Yes. Blacklion Construction Group is fully licensed and insured to build and renovate in Toronto and throughout the GTA. Every project, from a Toronto kitchen remodel to a full custom home build in Oakville, is backed by proper licensing, insurance coverage and a workmanship guarantee.",
  },
  {
    question: "How much does a home renovation cost in Toronto?",
    answer:
      "Renovation costs in Toronto vary based on scope, finishes and the condition of the existing structure. Kitchen and bathroom remodels, basement underpinning and full home renovations are each priced individually after a site visit. Contact our team for a free, no-obligation quote tailored to your Toronto, Mississauga or Etobicoke property.",
  },
  {
    question: "Do you build custom homes in Toronto and the GTA?",
    answer:
      "Yes, custom home building is one of our core services. We design and construct bespoke residences from the ground up for clients across Toronto, North York, Scarborough and the surrounding GTA, managing architecture, permits, trades and finishes under one accountable team.",
  },
  {
    question: "Do I need a permit for a basement renovation or underpinning in Toronto?",
    answer:
      "Most basement underpinning and structural renovation projects in Toronto require a building permit from the local municipality. Blacklion Construction Group handles the permit process on your behalf across Toronto, Etobicoke and North York, ensuring every basement upgrade is fully code-compliant and safe.",
  },
  {
    question: "How long does a kitchen or bathroom remodel typically take?",
    answer:
      "A standard kitchen or bathroom remodel in the Toronto and GTA area typically takes 4 to 8 weeks from demolition to final finishes, depending on the scope of work and material lead times. We provide a detailed project timeline before work begins so you know exactly what to expect.",
  },
  {
    question: "Do you handle both residential and commercial construction projects?",
    answer:
      "Yes. Blacklion Construction Group provides full-service general contracting for both residential clients and commercial developers throughout Toronto and the GTA, including Scarborough, Mississauga and Oakville, covering construction management, renovations, additions and new builds.",
  },
  {
    question: "How do I get a free renovation or construction quote?",
    answer:
      "Simply fill out the contact form below or call us directly at 647.967.8994. Our Toronto-based team will review your project details and get back to you with a free, no-obligation quote, typically within one to two business days.",
  },
];
